<template>
  <div class="row">
    <div class="col-md-12">
      <modal :modalContentClasses="{'no-close-on-backdrop':false}" :show.sync="ModalDealer">
        <template slot="header">
          <h5 class="modal-title sub_title sub_title" id="exampleModalLabel" v-show="btn_create">Crear Repartidor</h5>
          <h5 class="modal-title sub_title sub_title" id="exampleModalLabel1" v-show="btn_update">Editar Repartidor</h5>
        </template>
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-3">
                <label for="name">Nombre</label>
                <ValidationProvider name="user.name" rules="required" v-slot="{ errors }">
                  <input
                      id="name"
                      v-model="user.name"
                      type="text"
                      class="form-control"
                      placeholder="Nombre"
                  >
                  <p>{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
              <div class="col-3">
                <label for="last_name">Apellido</label>
                <ValidationProvider name="user.last_name" rules="required" v-slot="{ errors }">
                  <input
                      id="last_name"
                      v-model="user.last_name"
                      type="text"
                      class="form-control"
                      placeholder="Apellido"
                  >
                  <p>{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
              <div class="col-3">
                <label for="phone">Teléfono</label>
                <ValidationProvider name="user.phone" rules="required" v-slot="{ errors }">
                  <input
                      id="phone"
                      v-model="user.phone"
                      type="number"
                      class="form-control"
                      placeholder="Teléfono"
                      min="1"
                  >
                  <p>{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
              <div class="col-3">
                <label for="name">Documento</label>
                <input
                    id="docuemento"
                    v-model="user.document"
                    type="number"
                    class="form-control"
                    placeholder="Documento"
                    rules="required"
                    min="1"
                >
              </div>
              <div class="col-4">
                <label for="email">Correo</label>
                <ValidationProvider name="user.email" rules="required" v-slot="{ errors }">
                  <input
                      id="email"
                      v-model="user.email"
                      type="email"
                      class="form-control"
                      placeholder="Correo"
                  >
                  <p>{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
              <div class="col-3">
                <label for="user_pass">Contraseña</label>
                <ValidationProvider name="user.user_pass" v-slot="{ errors }">
                  <input
                      id="user_pass"
                      v-model="user.user_pass"
                      type="password"
                      class="form-control"
                      placeholder="Contraseña"
                  >
                  <p>{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
              <div class="col-3">
                <label> Estado del repartidor</label>
                <div class="radio-default-acre">
                  <PrettyRadio name="user_status" v-model="user.user_status" :value="true">Activo</PrettyRadio>
                  <PrettyRadio name="user_status" v-model="user.user_status" :value="false">Desactivado</PrettyRadio>
                </div>
              </div>
              <div class="col-12">
                <div>
                  <label class="typo__label">Restaurantes asignados</label>

                  <multiselect v-model="user.restaurant" :options="restaurants" :multiple="true"
                               group-values="children" group-label="name"
                               :group-select="true" placeholder="Buscar o agregar uno nuevo"
                               track-by="name"
                               label="name">
                    <span slot="noResult">Oops! No se encontraron elementos en la consulta.</span>
                  </multiselect>


                </div>
              </div>
              <div class="col-12">
                <br>
                <base-button id="btn_create" type="primary btn_submit" v-show="btn_create" @click="create()"
                             :disabled="invalid">Crear
                </base-button>
                <base-button id="btn_update" type="primary btn_submit" v-show="btn_update" @click="update()"
                             :disabled="invalid">Aceptar
                </base-button>
              </div>

            </div>
          </form>
        </ValidationObserver>
        <template slot="footer">
          <base-alert type="danger" v-if="error">
            <strong>{{ error }}</strong>
          </base-alert>
        </template>
        <div class="row">
          <div class="col-12">
            <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                           label="Guardando">
            </base-progress>
          </div>
        </div>

      </modal>
    </div>
  </div>
</template>

<script>

import {bus} from './bus-dealers'

import {extend, ValidationProvider} from 'vee-validate'
import {ValidationObserver} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import {dealers_service} from "../../services/dealers/DealersService";
import swal from "sweetalert";
import PrettyRadio from 'pretty-checkbox-vue/radio';
import _ from "lodash";

var dealerusers
var resemail
var email
extend('email', (value) => {
  const re = /\S+@\S+\.\S+/

  resemail = _.filter(dealerusers, (r) => {
    if (r.email === value) {
      return r
    }
  })
  if (re.test(String(value).toLowerCase())) {
    if (resemail != undefined) {
      if (resemail.length > 0) {
        if (email != undefined && email === value) {
          return true
        } else {
          return 'Email ya existe'
        }
      } else {
        return true
      }
    } else {
      return true
    }
  } else {
    return 'Email no valido'
  }
})
extend('required', {
  ...required,
  message: 'Este campo es requerido'
})
export default {
  name: "CreateDealers",
  components: {ValidationProvider, ValidationObserver, PrettyRadio},
  data() {
    return {
      error: '',
      progress: 0,
      ModalDealer: false,
      btn_update: false,
      btn_create: true,
      selected: '',
      user_type: [],
      client_type: [],
      user: {
        name: '',
        last_name: '',
        phone: '',
        email: '',
        user_login: 'null',
        user_pass: '',
        user_status: 0,
        client_type_id: {
          client_type_id: null,
        },
        user_type_id: {
          user_type_id: 4,
        },
        restaurant: []
      },
      user_edit: {
        user_id: 0,
        name: '',
        last_name: '',
        phone: '',
        email: '',
        user_login: 'null',
        user_status: 0,
        client_type_id: {
          client_type_id: null,
        },
        user_type_id: {
          user_type_id: 4,
        },
        restaurant: []
      },
      restaurant_user: [],
      restaurants: [],
      users: {},
      pass_encry: ''

    }
  },
  methods: {
    showmodal() {
      this.cleanform()
      this.ModalDealer = !this.ModalDealer
    }, create() {
      try {

        if (this.user.user_pass != ''){
          this.error = ''
          this.progress = 50
          if (this.user.user_status === true) {
            this.user.user_status = 1
          } else {
            this.user.user_status = 0
          }
          dealers_service.CreateDealer(this.user)
        } else {
          this.error = 'Ingresa una contraseña'
        }

      } catch (e) {
        return e
      }
    },
    responsecreate(response) {
      if (response.statusText === "Created") {
        this.progress = 100
        this.cleanform()
        this.showmodal()
        dealers_service.GetAllDealers()
        swal({
          icon: "success",
          text: "Repartidor Registrado Correctamente",
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        swal({
          dangerMode: true,
          icon: "error",
          text: "El Repaartidor No se Ha Registrado Correctamente",
          button: "Aceptar"
        })
      }

    },
    update() {
      if (this.user_edit.user_id > 0) {
        this.progress = 50
        try {
          if (this.user.user_status === true) {
            this.user_edit.user_status = 1
          } else {
            this.user_edit.user_status = 0
          }
          this.user_edit.name = this.user.name
          this.user_edit.last_name = this.user.last_name
          this.user_edit.phone = this.user.phone
          this.user_edit.email = this.user.email
          this.user_edit.document = this.user.document
          if (this.user.user_pass != '') {
            this.user_edit.user_pass = this.user.user_pass
          }
          this.user_edit.restaurant = this.user.restaurant
          for (const prop in this.user_edit.restaurant) {
            this.user_edit.restaurant[prop].priority = Number(prop + 1)
          }
          //console.log(this.user_edit)
          dealers_service.UpdateDealer(this.user_edit)

        } catch (e) {

          return e
        }


      }
    },
    responseupdate(response) {

      if (response.status === 200) {
        this.progress = 100
        this.cleanform()
        this.showmodal()
        dealers_service.GetAllDealers()
        swal({
          icon: "success",
          text: "Repartidor Actualizado Correctamente",
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        swal({
          dangerMode: true,
          icon: "error",
          text: "No se Actualizo el Repartidor Registrado Correctamente",
          button: "Aceptar"
        })
      }

    },
    cleanform() {
      this.progress = 0
      this.user.name = ''
      this.user.last_name = ''
      this.user.phone = ''
      this.user.email = ''
      this.user.user_login = 'null'
      this.user.user_pass = ''
      this.user.document = ''
      this.user.user_status = 0
      this.user.client_type_id.client_type_id = null
      this.user.user_type_id.user_type_id = 4
      this.user.restaurant = []
      this.user_edit = {
        user_id: 0,
        name: '',
        last_name: '',
        phone: '',
        email: '',
        user_login: 'null',
        user_status: 0,
        //client_type_id: {
        //  client_type_id: null,
        //},
        user_type_id: {
          user_type_id: 4,
        },
        restaurant: []
      }
      this.btn_update = false
      this.btn_create = true
    }
  },
  created() {
    dealers_service.GetUsersByType(4)
    dealers_service.GetAllRestaurant()
    bus.$on('GetUsersByType', (response) => {
      console.log(response)
      dealerusers = response
    })
    bus.$on('ShowModal', () => {
      this.showmodal()
    })
    bus.$on('ResponseCreateDealer', (response) => {
      this.responsecreate(response)
    })
    bus.$on('GetEditDealer', (useredit) => {
      this.showmodal();
      this.btn_create = false
      this.btn_update = true
      this.user_edit.user_id = useredit.user_id
      this.user.name = useredit.name
      this.user.last_name = useredit.last_name
      this.user.phone = useredit.phone
      this.user.email = useredit.email
      //this.user.user_pass = useredit.user_pass
      this.pass_encry = useredit.user_pass
      this.user.document = useredit.document
      if (useredit.user_status === 1) {
        this.user.user_status = true
      } else {
        this.user.user_status = false
      }
      this.user.restaurant = useredit.restaurant
      email = useredit.email
    })
    bus.$on('GetAllRestaurant', (restaurants) => {
      this.restaurants = restaurants
    })

    bus.$on('ResponseUpdateDealer', (response) => {
      this.responseupdate(response)
    })
  }
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
@media screen and (min-width: 300px) and (max-width: 1001px) {
  .modal-body form > div.row {
    display: block;
  }

  .modal-body form > div.row > div {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .modal-body form > div.row > div label {
    width: 100%;
    text-align: left;
  }

  .modal-body form > div.row > div .radio-default-acre {
    display: flex;
    margin-bottom: 3em;
  }
}
</style>


